export class CurrentCountryTypes {
  static US = "us";
  static UK = "uk";
  static IE = "ie";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/country-type.ts